'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          link = _props.link,
          hidden = _props.hidden,
          avatar = _props.avatar,
          bordered = _props.bordered,
          fluid = _props.fluid,
          rounded = _props.rounded,
          circular = _props.circular,
          centered = _props.centered,
          spaced = _props.spaced,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['link', 'hidden', 'avatar', 'bordered', 'fluid', 'rounded', 'circular', 'centered', 'spaced', 'className']);

      var cx = (0, _classnames2.default)({
        link: link,
        hidden: hidden,
        avatar: avatar,
        bordered: bordered,
        fluid: fluid,
        rounded: rounded,
        circular: circular,
        centered: centered,
        spaced: spaced
      }, 'image', className);

      return _react2.default.createElement(_Box2.default, _extends({
        wrapper: 'img',
        ts: true,
        className: cx
      }, rest));
    }
  }]);

  return Image;
}(_react.Component);

Image.displayName = 'Image';

Image.propTypes = {
  link: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  avatar: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  fluid: _propTypes2.default.bool,
  rounded: _propTypes2.default.bool,
  circular: _propTypes2.default.bool,
  centered: _propTypes2.default.bool,
  spaced: _propTypes2.default.bool
};

exports.default = Image;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltYWdlLmpzIl0sIm5hbWVzIjpbIkltYWdlIiwicHJvcHMiLCJsaW5rIiwiaGlkZGVuIiwiYXZhdGFyIiwiYm9yZGVyZWQiLCJmbHVpZCIsInJvdW5kZWQiLCJjaXJjdWxhciIsImNlbnRlcmVkIiwic3BhY2VkIiwiY2xhc3NOYW1lIiwicmVzdCIsImN4IiwiZGlzcGxheU5hbWUiLCJwcm9wVHlwZXMiLCJib29sIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7O0lBRU1BLEs7Ozs7Ozs7Ozs7OzZCQUNLO0FBQUEsbUJBYUgsS0FBS0MsS0FiRjtBQUFBLFVBRUxDLElBRkssVUFFTEEsSUFGSztBQUFBLFVBR0xDLE1BSEssVUFHTEEsTUFISztBQUFBLFVBSUxDLE1BSkssVUFJTEEsTUFKSztBQUFBLFVBS0xDLFFBTEssVUFLTEEsUUFMSztBQUFBLFVBTUxDLEtBTkssVUFNTEEsS0FOSztBQUFBLFVBT0xDLE9BUEssVUFPTEEsT0FQSztBQUFBLFVBUUxDLFFBUkssVUFRTEEsUUFSSztBQUFBLFVBU0xDLFFBVEssVUFTTEEsUUFUSztBQUFBLFVBVUxDLE1BVkssVUFVTEEsTUFWSztBQUFBLFVBV0xDLFNBWEssVUFXTEEsU0FYSztBQUFBLFVBWUZDLElBWkU7O0FBY1AsVUFBSUMsS0FBSywwQkFDUDtBQUNFWCxrQkFERjtBQUVFQyxzQkFGRjtBQUdFQyxzQkFIRjtBQUlFQywwQkFKRjtBQUtFQyxvQkFMRjtBQU1FQyx3QkFORjtBQU9FQywwQkFQRjtBQVFFQywwQkFSRjtBQVNFQztBQVRGLE9BRE8sRUFZUCxPQVpPLEVBYVBDLFNBYk8sQ0FBVDs7QUFnQkEsYUFDRTtBQUNFLGlCQUFRLEtBRFY7QUFFRSxnQkFGRjtBQUdFLG1CQUFXRTtBQUhiLFNBSU1ELElBSk4sRUFERjtBQVFEOzs7Ozs7QUFHSFosTUFBTWMsV0FBTixHQUFvQixPQUFwQjs7QUFFQWQsTUFBTWUsU0FBTixHQUFrQjtBQUNoQmIsUUFBTSxvQkFBVWMsSUFEQTtBQUVoQmIsVUFBUSxvQkFBVWEsSUFGRjtBQUdoQlosVUFBUSxvQkFBVVksSUFIRjtBQUloQlgsWUFBVSxvQkFBVVcsSUFKSjtBQUtoQlYsU0FBTyxvQkFBVVUsSUFMRDtBQU1oQlQsV0FBUyxvQkFBVVMsSUFOSDtBQU9oQlIsWUFBVSxvQkFBVVEsSUFQSjtBQVFoQlAsWUFBVSxvQkFBVU8sSUFSSjtBQVNoQk4sVUFBUSxvQkFBVU07QUFURixDQUFsQjs7a0JBWWVoQixLIiwiZmlsZSI6IkltYWdlLmpzIiwic291cmNlUm9vdCI6IkQ6XFxQcm9qZWN0c1xccmVhY3QtdG9jYXNcXHNyYyJ9



//////////////////
// WEBPACK FOOTER
// ../lib/Image.js
// module id = 570
// module chunks = 0